module.exports = __webpack_public_path__ + "d267f55347bbc94b2b4d80eb0a6bf9c7.svg";